<template lang="pug">
  .address-ctas
    .address-add
      button.address-add__button(@click="show", v-show="!active") + Add New Address
      .address-form(v-show="active")
        slot
      a.address-add__button(
        href="/tools/recurring/login"
        v-show="!active && hasActiveSubs"
      ) +/- Manage Subscription Addresses
</template>

<script>
  export default {
    name: 'AccountNewAddress',
    props: {
      hasActiveSubs: Boolean,
    },
    data() {
      return {
        active: false
      }
    },
    mounted() {
      let provinceSelector = new Shopify.CountryProvinceSelector(`AddressCountryNew`, `AddressProvinceNew`, { hideElement: `AddressProvinceWrapperNew` });
    },
    methods: {
      show() {
        this.active = true;
      },
      hide() {
        this.active = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .address-add {
    display: flex;
  }
  // see account-addresses.scss for styling
  .button--subs {
    margin-top: 10px;
    padding-top: 24px;
    padding-bottom: 24px;
  }

  .address-form {
    width: 100%;
  }

  .address-add__button {
    margin-right: 5px;

    &:last-child {
      margin-right: 0;
      margin-left: 5px;
    }
  }
</style>
